import { StatementPayload, createLangString } from '@/app/tracking/xapi/tincan/client';

interface ExamPassedStatementParams {
  id: string;
  title: string;
  description?: string;
}

export function createExamPassedStatement(params: ExamPassedStatementParams) {

  const statement: StatementPayload = {
    verb: {
      id: 'http://adlnet.gov/expapi/verbs/passed',
      display: {
        'en-US': 'passed'
      }
    },
    object: {
      objectType: 'Activity',
      id: params.id,
      definition: {
        type: 'http://adlnet.gov/expapi/activities/assessment',
        name: createLangString(params.title),
        description: params.description ? createLangString(params.description) : undefined
      }
    }
  };

  return statement;
}
